import { Box, Typography } from "@mui/material";
import { VisibilityOutlined } from "@mui/icons-material";
import { useIntl } from "react-intl";
import { prepareSharedAnswer } from "component/chatbot/share/prepareSharedAnswer";
import SafeHtml from "component/chatbot/components/share/SafeHtml";
import { SharedAnswerMedia } from "component/chatbot/components/media/SharedMediaEmbeds";
import { detectTextDir } from "../utils";
import SharedPublicationCovers from "./SharedPublicationCovers";

export default function SharedMessagePair({ pair, index, dir }) {
  const intl = useIntl();

  const question = pair?.question ?? "";
  const answer = pair?.answer ?? "";
  const prepared = prepareSharedAnswer(answer, {
    links: pair?.links,
    linksCover: pair?.links_cover || pair?.linksCover,
    graph: pair?.graph || pair?.graphHtml,
    excelUrls: pair?.excelUrls || pair?.excel_urls,
  });
  const qDir = detectTextDir(question, dir);
  const aDir = detectTextDir(prepared.html || answer, dir);
  const delay = Math.min(index * 0.06, 0.42);
  const hasMedia =
    (prepared.media && prepared.media.length > 0) ||
    Boolean(prepared.graphHtml);
  const hasAnswerBody =
    Boolean(prepared.html && String(prepared.html).trim()) ||
    hasMedia ||
    Boolean(
      prepared.links &&
        prepared.linksCover &&
        Object.keys(prepared.links).length,
    );

  return (
    <Box
      className="shared-chat-pair"
      style={{ animationDelay: `${delay}s` }}
    >
      {question !== "" && question != null && (
        <Box className="shared-chat-row shared-chat-row--user">
          <Box
            className="shared-chat-bubble shared-chat-bubble--user"
            dir={qDir}
          >
            <Typography className="shared-chat-text">
              {String(question)}
            </Typography>
          </Box>
          <Box className="shared-chat-avatar shared-chat-avatar--user" aria-hidden>
            <VisibilityOutlined fontSize="small" />
          </Box>
        </Box>
      )}

      {hasAnswerBody && (
        <Box className="shared-chat-row shared-chat-row--assistant">
          <Box
            className="shared-chat-avatar shared-chat-avatar--assistant"
            aria-hidden
          >
            <img src="/logo.png" alt="" />
          </Box>
          <Box
            className="shared-chat-bubble shared-chat-bubble--assistant"
            dir={aDir}
          >
            <Box className="shared-chat-assistant-meta">
              <Typography className="shared-chat-role">
                {intl.formatMessage({
                  id: "chatbot.name",
                  defaultMessage: "CAPMAS Assistant",
                })}
              </Typography>
            </Box>
            {prepared.html ? (
              <SafeHtml
                html={prepared.html}
                className="shared-chat-html"
                dir={aDir}
              />
            ) : null}
            <SharedAnswerMedia
              media={prepared.media}
              graphHtml={prepared.graphHtml}
            />
            <SharedPublicationCovers
              links={prepared.links}
              linksCover={prepared.linksCover}
              dir={aDir}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
